import React, { FC, ReactNode } from "react";
import { LDProvider } from "launchdarkly-react-client-sdk";
import { User } from "shared-auth";
import { buildUser } from "./utils";
import config from "../../config";

type LaunchDarklyProviderProps = {
  thisUser: User | null | undefined;
  children: ReactNode;
};

const LaunchDarklyProvider: FC<
  React.PropsWithChildren<LaunchDarklyProviderProps>
> = ({ children, thisUser }) => {
  return (
    <LDProvider
      clientSideID={config.launchDarkly.clientSideID}
      context={{
        kind: "user",
        ...buildUser(thisUser),
      }}
      reactOptions={{
        useCamelCaseFlagKeys: false,
      }}
    >
      {children}
    </LDProvider>
  );
};

export default LaunchDarklyProvider;
